













import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { ClientPolicyDto } from '@core/pages/CommissionModule/api'
import { FormStructure } from '@master/model/structure/FormStructure'
import { options } from '@core/model/UIOptions'

@Component({
  components: {
    AppForm
  }
})
export default class ILPDetailSection extends Vue {
  @Prop({ default: {} }) policyInView: ClientPolicyDto
  @Prop({ default: () => [] }) productOptions: []
  @Prop({ default: () => [] }) riskRatingOptions: []
  @Prop({ default: () => [] }) frequencyOptions: options[]

  get isDisabled () {
    // @TODO: To remove away so that it doesnt have any access to store
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get isAutoCreated () {
    return this.policyInView?.creationType === 'auto'
  }

  /* eslint-disable @typescript-eslint/camelcase */
  get subPolicyStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Fund Name',
        key: 'productOid',
        options: [
          { label: '', value: '' },
          ...this.productOptions
        ],
        disabled: this.isDisabled || this.isAutoCreated
      },
      {
        label: 'Investment Amount ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.investmentAmount,
          set: (val) => {
            this.policyInView.productMetadata.investmentAmount = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Frequency',
        model: {
          get: () => this.policyInView.productMetadata?.frequency,
          set: (val) => {
            this.policyInView.productMetadata.frequency = val
          }
        },
        options: this.frequencyOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Approved Date',
        key: 'startDate',
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'End Date',
        key: 'endDate',
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'Unit Balance',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.regularUnitBalance,
          set: (val) => {
            this.policyInView.productMetadata.regularUnitBalance = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Risk Class',
        model: {
          get: () => this.policyInView.productMetadata?.regularRiskClass,
          set: (val) => {
            this.policyInView.productMetadata.regularRiskClass = val
          }
        },
        options: this.riskRatingOptions,
        disabled: true
      },
      {
        label: 'Cash ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.regularRegularCash,
          set: (val) => {
            this.policyInView.productMetadata.regularRegularCash = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Stock ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.regularRegularStock,
          set: (val) => {
            this.policyInView.productMetadata.regularRegularStock = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Bonds ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.regularRegularBonds,
          set: (val) => {
            this.policyInView.productMetadata.regularRegularBonds = val
          }
        },
        disabled: this.isDisabled
      }
    ]
  }
}
